import React from "react";
import ReactDOM from "react-dom";
import RentingRequestsTable from "./index";

export default async function renderRentingRequestsTable({
  target = "renting-requests-table-container",
  ...rest
}) {
  const domTarget = document.getElementById(target);

  if (domTarget) {
    ReactDOM.render(<RentingRequestsTable {...rest} />, domTarget);
  }
}
